module.exports = __webpack_public_path__ + "static/media/5922.42a4c205.jpg";